module.exports = __webpack_public_path__ + "static/media/pia.a7493aa3.jpg";